import { Box, Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { FormattedMessage } from 'react-intl';

import { tierConfig } from 'constants/loyalty.constants';
import { LoyaltyTierName } from 'types/api/account.types';

import {
  GradientImage,
  NoiseImage,
} from 'components/@loyalty/Card/Card.styles';
import LandscapeCardContainer from 'components/@loyalty/LandscapeCardContainer';
import { getMembershipCardIcon } from 'components/@loyalty/utils';

interface Props {
  tier: LoyaltyTierName;
  size?: 'small' | 'medium';
  isCurrentTier?: boolean;
}
const LoyaltyCardLandscape = ({
  tier,
  size = 'medium',
  isCurrentTier,
}: Props) => {
  const config = tierConfig[tier];
  const icons = getMembershipCardIcon(tier);
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <>
      <LandscapeCardContainer
        backgroundColor={config.backgroundColor}
        borderColor={config.borderColor}
        mixBlendMode={config.mixBlendMode}
        size={size}
      >
        {/* SR + NF Logo's */}
        {size === 'medium' && (
          <>
            <Image
              src={icons.nf}
              height={16}
              width={40}
              alt="Nofomo Logo"
              style={{
                mixBlendMode: config.mixBlendMode,
                opacity: !!config?.subLayer ? 0.6 : 0.9,
                objectFit: 'contain',
                position: 'absolute',
                top: 24,
                right: 24,
              }}
              unoptimized
              priority
            />
          </>
        )}
        {isCurrentTier && (
          <Box
            sx={{
              position: 'absolute',
              top: 9,
              backgroundColor: config.borderColor,
              mixBlendMode: config.mixBlendMode,
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              px: '6px',
              pt: '3px',
            }}
          >
            <Typography
              variant="extraSmall"
              textTransform="uppercase"
              fontWeight={700}
              color={!!config?.subLayer ? '#000' : '#fff'}
              sx={{ fontSize: 10 }}
            >
              <FormattedMessage id="loyalty.detail.current_tier.label" />
            </Typography>
          </Box>
        )}
        <GradientImage variant="landscape" />
        {!!config?.subLayer && (
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              background: config.subLayer,
              mixBlendMode: 'soft-light',
              opacity: 0.3,
            }}
          />
        )}
        <NoiseImage variant="landscape" />

        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            width: '100%',
            marginTop: size === 'small' ? 0 : 2,
          }}
        >
          <Image
            src={config.textImage}
            height={size === 'small' ? (isMobile ? 45 : 54) : 54}
            width={size === 'small' ? (isMobile ? 93 : 145) : 145}
            alt="Loyalty Logo"
            style={{
              mixBlendMode: config.mixBlendMode,
              objectFit: 'contain',
            }}
            unoptimized
            priority
          />
        </Stack>
      </LandscapeCardContainer>
    </>
  );
};

export default LoyaltyCardLandscape;
